import ControlledInputField from 'views/components/common/Form/ReactForm/ControlledInputField/ControlledInputField';

export default ControlledInputField;
